import {api} from "@/lib/api/auth/api";
import {IContactVerifyState} from "@/lib/types/auth/IContactVerifyState";
import {ILoginRequestCaptcha} from "@/lib/types/auth/ILoginRequestCaptcha";

export const contactVerifyApi = api.injectEndpoints({
    endpoints: build => ({
        getContactVerifyState: build.query<IContactVerifyState, void>({
            query: () => ({
                url: '/contact-verification/state',
                method: 'get',
            }),
            // transformResponse: (response: IContactVerifyState) => {
            //     if (!response.nextContactReminderAt) return response;
            //     return {
            //         ...response,
            //         // nextContactReminderAt: new Date(Date.now() - 30_000).toISOString(),
            //         // hardModalRequired: true,
            //     };
            // },
            providesTags: ['ContactVerifyState'],
        }),
        markSoftModalShown: build.mutation<IContactVerifyState, void>({
            query: () => ({
                url: '/contact-verification/soft-modal-shown',
                method: 'post',
            }),
            invalidatesTags: ['ContactVerifyState'],
        }),
        markAddNowClicked: build.mutation<IContactVerifyState, void>({
            query: () => ({
                url: '/contact-verification/add-now-clicked',
                method: 'post',
            }),
            invalidatesTags: ['ContactVerifyState'],
        }),
        markRemindLater: build.mutation<IContactVerifyState, void>({
            query: () => ({
                url: '/contact-verification/remind-later',
                method: 'post',
            }),
            invalidatesTags: ['ContactVerifyState'],
        }),
        markToastShown: build.mutation<IContactVerifyState, void>({
            query: () => ({
                url: '/contact-verification/toast-shown',
                method: 'post',
            }),
            invalidatesTags: ['ContactVerifyState'],
        }),
        markToastClicked: build.mutation<IContactVerifyState, void>({
            query: () => ({
                url: '/contact-verification/toast-clicked',
                method: 'post',
            }),
            invalidatesTags: ['ContactVerifyState'],
        }),
        requestPhoneVerificationCode: build.mutation<void, {phoneNumber: string; captchaDto?: ILoginRequestCaptcha | null}>({
            query: (body) => ({
                url: '/contact-verification/phone/code',
                method: 'post',
                body: {captchaDto: null, ...body},
            }),
        }),
        verifyPhoneCode: build.mutation<IContactVerifyState, {phoneNumber: string; code: string}>({
            query: (body) => ({
                url: '/contact-verification/phone/verify',
                method: 'post',
                body,
            }),
            invalidatesTags: ['ContactVerifyState'],
        }),
        requestEmailCode: build.mutation<void, {email: string; captchaDto?: ILoginRequestCaptcha | null}>({
            query: (body) => ({
                url: '/contact-verification/email/code',
                method: 'post',
                body: {captchaDto: null, ...body},
            }),
        }),
        confirmEmail: build.mutation<IContactVerifyState, {userId: string; email: string; token: string}>({
            query: (body) => ({
                url: '/contact-verification/email/confirm',
                method: 'post',
                body,
            }),
            invalidatesTags: ['ContactVerifyState'],
        }),
    }),
})

export const {
    useGetContactVerifyStateQuery,
    useMarkSoftModalShownMutation,
    useMarkAddNowClickedMutation,
    useMarkRemindLaterMutation,
    useMarkToastShownMutation,
    useMarkToastClickedMutation,
    useRequestPhoneVerificationCodeMutation,
    useVerifyPhoneCodeMutation,
    useRequestEmailCodeMutation,
    useConfirmEmailMutation,
} = contactVerifyApi;
